import { render, staticRenderFns } from "./AddressVerificationStatus.vue?vue&type=template&id=52c7abea&scoped=true"
import script from "./AddressVerificationStatus.vue?vue&type=script&lang=js"
export * from "./AddressVerificationStatus.vue?vue&type=script&lang=js"
import style0 from "./AddressVerificationStatus.vue?vue&type=style&index=0&id=52c7abea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c7abea",
  null
  
)

export default component.exports